import React from "react";
import CourierInfo from "./CourierInfo";
import CourierServices from "./CourierServices";
import CourierServiceForm from "../form/CourierServiceForm";
import useCourierDetail from "../../hooks/useCourierDetail";
import ModalDeleteConfirmation from "components/modals/components/DeleteConfirmation";
import { ICourierService } from "../../types/courier.interface";
import { useNavigate, useParams } from "react-router-dom";
import { useDisclosure } from "@chakra-ui/react";
import { createPortal } from "react-dom";
import { toast } from "react-hot-toast";
import { Actions } from "constants/actions";

const CourierProfile = () => {
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [action, setAction] = React.useState<Actions | null>(null);
  const [intendedItem, setIntendedItem] =
    React.useState<ICourierService | null>(null);
  const {
    courier,
    services,
    isLoading,
    getCourierDetail,
    handleRemoveService,
  } = useCourierDetail(id);

  const openModal = (props: ICourierService) => {
    setIntendedItem(props);
    onOpen();
  };

  const closeModal = () => {
    setIntendedItem(null);
    onClose();
  };

  React.useEffect(() => {
    if (id) getCourierDetail();
    else {
      toast.error("Kurir tidak ditemukan!");
      navigate("/admin/couriers");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <section className="mt-5">
        <CourierInfo courier={courier} isLoading={isLoading} />
        {courier && !courier?.is_third_party ? (
          <CourierServices
            services={services}
            openUpdateModal={(service) => {
              setAction(Actions.UPDATE);
              openModal(service);
            }}
            openDeleteModal={(service) => {
              setAction(Actions.DELETE);
              openModal(service);
            }}
            onOpen={() => {
              setAction(Actions.CREATE);
              onOpen();
            }}
          />
        ) : (
          <></>
        )}
      </section>
      {createPortal(
        <CourierServiceForm
          courierId={parseInt(id)}
          service={intendedItem}
          isOpen={isOpen && action !== Actions.DELETE}
          onClose={closeModal}
        />,
        document.body
      )}
      {createPortal(
        <ModalDeleteConfirmation
          isOpen={isOpen && action === Actions.DELETE}
          onClose={closeModal}
          onDelete={handleRemoveService}
          itemName={intendedItem?.name}
          itemId={intendedItem?.id}
        />,
        document.body
      )}
    </>
  );
};

export default CourierProfile;
